"use client";
import { Link, useRouteError } from "react-router";
import { Button } from "app/components/shadcn/button.tsx";
import { captureException } from "@sentry/react";
import { useEffect } from "react";

export default function AppErrorBoundary() {
  const error = useRouteError();
  useEffect(() => {
    console.log(error);
    captureException(error);
  }, [error]);

  return (
    <main className="p-4 md:p-6">
      <div className="mb-8 space-y-4">
        <h1 className="font-bold text-3xl text-red-500">
          Something went wrong :/
        </h1>
        <p className="py-1">
          We couldn't load the page. Please, try again later.
        </p>
        <p>If the issue persists, contact support.</p>
        <Button>
          <Link to="/">Navigate to the main page</Link>
        </Button>
      </div>
    </main>
  );
}
